import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Button,
} from '@mui/material';
import {
  PictureAsPdf as PdfIcon,
  OpenInNew as OpenInNewIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ScriptsForms = () => {
  const { t } = useTranslation();

  const resources = [
    {
      title: t('scriptsForms.eipScript'),
      description: t('scriptsForms.eipScriptDesc'),
      url: 'https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:f0a4a69f-7323-40e9-9559-8b869e43377a',
      color: '#2C9C6C',
    },
    {
      title: t('scriptsForms.iulTerm'),
      description: t('scriptsForms.iulTermDesc'),
      url: 'https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:e3bdebaa-bbd0-41f5-9b20-71f3c29122e8',
      color: '#4DC896',
    },
    {
      title: t('scriptsForms.wholeLife'),
      description: t('scriptsForms.wholeLifeDesc'),
      url: 'https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:fb26c899-7e78-4b33-a24c-5cf981bb1fbc',
      color: '#c9a84c',
    },
  ];

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        {t('scriptsForms.title', 'Scripts + Forms')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
        {t('scriptsForms.subtitle', 'Sales scripts, cheat sheets, and essential forms.')}
      </Typography>

      <Grid container spacing={3}>
        {resources.map((resource, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper
              sx={{
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                },
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 4,
                  bgcolor: resource.color,
                }}
              />
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: 2,
                  bgcolor: `${resource.color}15`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                  mt: 1,
                }}
              >
                <PdfIcon sx={{ fontSize: 32, color: resource.color }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                {resource.title}
              </Typography>
              <Typography sx={{ color: 'text.secondary', mb: 3, fontSize: '0.9rem', lineHeight: 1.6, flex: 1 }}>
                {resource.description}
              </Typography>
              <Button
                variant="outlined"
                endIcon={<OpenInNewIcon />}
                href={resource.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  borderColor: resource.color,
                  color: resource.color,
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: resource.color,
                    bgcolor: `${resource.color}10`,
                  },
                }}
              >
                {t('scriptsForms.viewPdf')}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ScriptsForms;
